module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/home/components/home-main-modal-detail/auction-type-change-email-dialog/auction-type-change-email-dialog.component.sass
// module id = ./src/app/modules/home/components/home-main-modal-detail/auction-type-change-email-dialog/auction-type-change-email-dialog.component.sass
// module chunks = main